export default function PHP_preg_replace() {
  return (
    <div>
      <h1>PHP_preg_replace</h1>
    </div>
  );
}
